import React from 'react';
import { useTranslation } from 'react-i18next';
import './ReserveButton.css';

interface ReserveButtonProps {
  variant?: 'dark' | 'light'; 
  children?: React.ReactNode; 
}

const ReserveButton: React.FC<ReserveButtonProps> = ({ variant = 'dark', children }) => {
 
  const { t } = useTranslation();
  
  const btnClass = `reserve-btn ${variant}`;

  return (
    
    <a href="#" className={btnClass}>
      
     
      {children || t('buttons:reserveNow')}
      
    </a>
  );
};

export default ReserveButton;